import { HttpClient } from '@angular/common/http';
import { FeatureApiConfig } from './api/feature-flags-api.config';
import { FeatureFlagsApiService } from './api/feature-flags-api.service';
import { FeatureFlagContextService } from './client/feature-flag-context.service';
import { FeatureFlagClientService } from './client/feature-flag-client.service';
import { RemoteFeatureTogglerService } from './remote-feature-toggler.service';
import { CbreLogger } from '@cbre/logger';

/**
 * Factory function to create a RemoteFeatureTogglerService instance
 *
 * @param http The Angular HttpClient
 * @param config The feature API configuration
 * @param contextService The user context service
 * @param featureFlagClientService The client-side feature flag evaluation service
 * @param logger The CbreLogger instance
 * @returns A new RemoteFeatureTogglerService instance
 */
export function RemoteFeatureTogglerServiceFactory(
  http: HttpClient,
  config: FeatureApiConfig,
  contextService: FeatureFlagContextService,
  featureFlagClientService: FeatureFlagClientService,
  logger: CbreLogger
): RemoteFeatureTogglerService {
  const apiService = new FeatureFlagsApiService(http, config, logger);
  return new RemoteFeatureTogglerService(apiService, contextService, featureFlagClientService, logger);
}
